import React from 'react';
import { useCopy } from '.';

const Copy = ({ children }) => {
  const copy = useCopy();
  return copy[children] || null;
};

export default Copy;
